/* Added the following code for POW-938.Harsha using AI Agent. September 20, 2026. Code Start */
/**
 * Shared notifications state (REST + STOMP) for the header bell and toast popups.
 */
import React, { createContext, useContext } from 'react';
import { useNotifications } from 'app/hooks/useNotifications';

const NotificationsContext = createContext(null);

export function NotificationsProvider({ children, enabled = true }) {
	const value = useNotifications(enabled);
	return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
}

export function useNotificationsContext() {
	const context = useContext(NotificationsContext);
	if (!context) {
		throw new Error('useNotificationsContext must be used within NotificationsProvider');
	}
	return context;
}
/* Code end. Harsha using AI Agent. September 20, 2026 */
